import React, { FC } from 'react';
import { Entry } from 'contentful';

import { TypeProductMerchCardFields } from '@/core/generated-types';
import { CONTENT_TYPE_PRODUCT_MERCH_CARD_LAYOUT_TYPE } from '@/core/constants';
import { ExtendedProductFields } from '@/core/contentfulConfig';

import { CartCtaCard } from './CartCtaCard';
import { DefaultCard } from './DefaultCard';

export interface TypeProductMerchCardProps extends TypeProductMerchCardFields {
  isHidden?: boolean;
}

export interface ExtendedProductMerchCardProps
  extends Omit<TypeProductMerchCardProps, 'product'> {
  product: Entry<ExtendedProductFields>;
}

const ProductMerchCard: FC<ExtendedProductMerchCardProps> = ({
  layoutType,
  product,
  includes,
  includesLabel,
  productWithAddonsPricePrefix,
  pdpLink,
  isHidden,
  backgroundTint,
}) => {
  if (isHidden) {
    return null;
  }

  switch (layoutType) {
    case CONTENT_TYPE_PRODUCT_MERCH_CARD_LAYOUT_TYPE.CART_CTA:
      return (
        <CartCtaCard
          product={product}
          includes={includes}
          includesLabel={includesLabel}
          productWithAddonsPricePrefix={productWithAddonsPricePrefix}
          pdpLink={pdpLink}
        />
      );
    case CONTENT_TYPE_PRODUCT_MERCH_CARD_LAYOUT_TYPE.DEFAULT:
    default:
      return (
        <DefaultCard
          product={product}
          includes={includes}
          includesLabel={includesLabel}
          productWithAddonsPricePrefix={productWithAddonsPricePrefix}
          pdpLink={pdpLink}
          backgroundTint={backgroundTint}
        />
      );
  }
};

export default ProductMerchCard;
